import Head from "next/head";
import { seoLocales } from "@/hooks/seoLocales";

export default function SeoHead({
  title,
  description,
  canonical,
  image,
  domain,
}) {

  const ogLocale =
    seoLocales[domain]?.ogLocale || "en_US";

  // JSON-LD with primaryImageOfPage so Google picks the right thumbnail
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "url": canonical,
    "primaryImageOfPage": image,
  };

  return (
    <Head>
      <title>{title}</title>

      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:locale" content={ogLocale} />

      {/* JSON-LD: tell Google which image represents this page */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

    </Head>
  );
}